/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated.activity'
import { Route as AuthenticatedAppointmentsRouteImport } from './routes/_authenticated.appointments'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated.reports'
import { Route as AuthenticatedReviewsRouteImport } from './routes/_authenticated.reviews'
import { Route as AuthenticatedSessionsRouteImport } from './routes/_authenticated.sessions'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated.account.index'
import { Route as AuthenticatedAccountAppearanceRouteImport } from './routes/_authenticated.account.appearance'
import { Route as AuthenticatedAccountProfileRouteImport } from './routes/_authenticated.account.profile'
import { Route as AuthenticatedAccountSessionsRouteImport } from './routes/_authenticated.account.sessions'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated.companies.index'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated.companies.$companyId'
import { Route as AuthenticatedCompaniesPendingRouteImport } from './routes/_authenticated.companies.pending'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated.users.index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated.users.$userId'
import { Route as AuthenticatedCompaniesCompanyIdIndexRouteImport } from './routes/_authenticated.companies.$companyId.index'
import { Route as AuthenticatedCompaniesCompanyIdAvailabilityRouteImport } from './routes/_authenticated.companies.$companyId.availability'
import { Route as AuthenticatedCompaniesCompanyIdImagesRouteImport } from './routes/_authenticated.companies.$companyId.images'
import { Route as AuthenticatedCompaniesCompanyIdReadinessRouteImport } from './routes/_authenticated.companies.$companyId.readiness'
import { Route as AuthenticatedCompaniesCompanyIdReviewsRouteImport } from './routes/_authenticated.companies.$companyId.reviews'
import { Route as AuthenticatedCompaniesCompanyIdSettingsRouteImport } from './routes/_authenticated.companies.$companyId.settings'
import { Route as AuthenticatedCompaniesCompanyIdAppointmentsIndexRouteImport } from './routes/_authenticated.companies.$companyId.appointments.index'
import { Route as AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRouteImport } from './routes/_authenticated.companies.$companyId.appointments.$appointmentId'
import { Route as AuthenticatedCompaniesCompanyIdEmployeesIndexRouteImport } from './routes/_authenticated.companies.$companyId.employees.index'
import { Route as AuthenticatedCompaniesCompanyIdServicesIndexRouteImport } from './routes/_authenticated.companies.$companyId.services.index'
import { Route as AuthenticatedCompaniesCompanyIdServicesServiceIdRouteImport } from './routes/_authenticated.companies.$companyId.services.$serviceId'
import { Route as AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRouteImport } from './routes/_authenticated.companies.$companyId.employees.$employeeId.work-hours'
import { Route as AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRouteImport } from './routes/_authenticated.companies.$companyId.services.$serviceId.assignments'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppointmentsRoute =
  AuthenticatedAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReviewsRoute = AuthenticatedReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSessionsRoute = AuthenticatedSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountAppearanceRoute =
  AuthenticatedAccountAppearanceRouteImport.update({
    id: '/account/appearance',
    path: '/account/appearance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountProfileRoute =
  AuthenticatedAccountProfileRouteImport.update({
    id: '/account/profile',
    path: '/account/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountSessionsRoute =
  AuthenticatedAccountSessionsRouteImport.update({
    id: '/account/sessions',
    path: '/account/sessions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesPendingRoute =
  AuthenticatedCompaniesPendingRouteImport.update({
    id: '/companies/pending',
    path: '/companies/pending',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdIndexRoute =
  AuthenticatedCompaniesCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdAvailabilityRoute =
  AuthenticatedCompaniesCompanyIdAvailabilityRouteImport.update({
    id: '/availability',
    path: '/availability',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdImagesRoute =
  AuthenticatedCompaniesCompanyIdImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdReadinessRoute =
  AuthenticatedCompaniesCompanyIdReadinessRouteImport.update({
    id: '/readiness',
    path: '/readiness',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdReviewsRoute =
  AuthenticatedCompaniesCompanyIdReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdSettingsRoute =
  AuthenticatedCompaniesCompanyIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute =
  AuthenticatedCompaniesCompanyIdAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute =
  AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRouteImport.update({
    id: '/appointments/$appointmentId',
    path: '/appointments/$appointmentId',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdEmployeesIndexRoute =
  AuthenticatedCompaniesCompanyIdEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdServicesIndexRoute =
  AuthenticatedCompaniesCompanyIdServicesIndexRouteImport.update({
    id: '/services/',
    path: '/services/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdServicesServiceIdRoute =
  AuthenticatedCompaniesCompanyIdServicesServiceIdRouteImport.update({
    id: '/services/$serviceId',
    path: '/services/$serviceId',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute =
  AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRouteImport.update(
    {
      id: '/employees/$employeeId/work-hours',
      path: '/employees/$employeeId/work-hours',
      getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
    } as any,
  )
const AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute =
  AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRouteImport.update(
    {
      id: '/assignments',
      path: '/assignments',
      getParentRoute: () =>
        AuthenticatedCompaniesCompanyIdServicesServiceIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/reviews': typeof AuthenticatedReviewsRoute
  '/sessions': typeof AuthenticatedSessionsRoute
  '/account/appearance': typeof AuthenticatedAccountAppearanceRoute
  '/account/profile': typeof AuthenticatedAccountProfileRoute
  '/account/sessions': typeof AuthenticatedAccountSessionsRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  '/companies/pending': typeof AuthenticatedCompaniesPendingRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/companies/$companyId/availability': typeof AuthenticatedCompaniesCompanyIdAvailabilityRoute
  '/companies/$companyId/images': typeof AuthenticatedCompaniesCompanyIdImagesRoute
  '/companies/$companyId/readiness': typeof AuthenticatedCompaniesCompanyIdReadinessRoute
  '/companies/$companyId/reviews': typeof AuthenticatedCompaniesCompanyIdReviewsRoute
  '/companies/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsRoute
  '/companies/$companyId/': typeof AuthenticatedCompaniesCompanyIdIndexRoute
  '/companies/$companyId/appointments/$appointmentId': typeof AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute
  '/companies/$companyId/services/$serviceId': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren
  '/companies/$companyId/appointments/': typeof AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute
  '/companies/$companyId/employees/': typeof AuthenticatedCompaniesCompanyIdEmployeesIndexRoute
  '/companies/$companyId/services/': typeof AuthenticatedCompaniesCompanyIdServicesIndexRoute
  '/companies/$companyId/employees/$employeeId/work-hours': typeof AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute
  '/companies/$companyId/services/$serviceId/assignments': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/reviews': typeof AuthenticatedReviewsRoute
  '/sessions': typeof AuthenticatedSessionsRoute
  '/account/appearance': typeof AuthenticatedAccountAppearanceRoute
  '/account/profile': typeof AuthenticatedAccountProfileRoute
  '/account/sessions': typeof AuthenticatedAccountSessionsRoute
  '/companies/pending': typeof AuthenticatedCompaniesPendingRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/companies/$companyId/availability': typeof AuthenticatedCompaniesCompanyIdAvailabilityRoute
  '/companies/$companyId/images': typeof AuthenticatedCompaniesCompanyIdImagesRoute
  '/companies/$companyId/readiness': typeof AuthenticatedCompaniesCompanyIdReadinessRoute
  '/companies/$companyId/reviews': typeof AuthenticatedCompaniesCompanyIdReviewsRoute
  '/companies/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdIndexRoute
  '/companies/$companyId/appointments/$appointmentId': typeof AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute
  '/companies/$companyId/services/$serviceId': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren
  '/companies/$companyId/appointments': typeof AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute
  '/companies/$companyId/employees': typeof AuthenticatedCompaniesCompanyIdEmployeesIndexRoute
  '/companies/$companyId/services': typeof AuthenticatedCompaniesCompanyIdServicesIndexRoute
  '/companies/$companyId/employees/$employeeId/work-hours': typeof AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute
  '/companies/$companyId/services/$serviceId/assignments': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRoute
  '/_authenticated/appointments': typeof AuthenticatedAppointmentsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/reviews': typeof AuthenticatedReviewsRoute
  '/_authenticated/sessions': typeof AuthenticatedSessionsRoute
  '/_authenticated/account/appearance': typeof AuthenticatedAccountAppearanceRoute
  '/_authenticated/account/profile': typeof AuthenticatedAccountProfileRoute
  '/_authenticated/account/sessions': typeof AuthenticatedAccountSessionsRoute
  '/_authenticated/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  '/_authenticated/companies/pending': typeof AuthenticatedCompaniesPendingRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/companies/$companyId/availability': typeof AuthenticatedCompaniesCompanyIdAvailabilityRoute
  '/_authenticated/companies/$companyId/images': typeof AuthenticatedCompaniesCompanyIdImagesRoute
  '/_authenticated/companies/$companyId/readiness': typeof AuthenticatedCompaniesCompanyIdReadinessRoute
  '/_authenticated/companies/$companyId/reviews': typeof AuthenticatedCompaniesCompanyIdReviewsRoute
  '/_authenticated/companies/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsRoute
  '/_authenticated/companies/$companyId/': typeof AuthenticatedCompaniesCompanyIdIndexRoute
  '/_authenticated/companies/$companyId/appointments/$appointmentId': typeof AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute
  '/_authenticated/companies/$companyId/services/$serviceId': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren
  '/_authenticated/companies/$companyId/appointments/': typeof AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute
  '/_authenticated/companies/$companyId/employees/': typeof AuthenticatedCompaniesCompanyIdEmployeesIndexRoute
  '/_authenticated/companies/$companyId/services/': typeof AuthenticatedCompaniesCompanyIdServicesIndexRoute
  '/_authenticated/companies/$companyId/employees/$employeeId/work-hours': typeof AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute
  '/_authenticated/companies/$companyId/services/$serviceId/assignments': typeof AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/login'
    | '/activity'
    | '/appointments'
    | '/dashboard'
    | '/reports'
    | '/reviews'
    | '/sessions'
    | '/account/appearance'
    | '/account/profile'
    | '/account/sessions'
    | '/companies/$companyId'
    | '/companies/pending'
    | '/users/$userId'
    | '/account/'
    | '/companies/'
    | '/users/'
    | '/companies/$companyId/availability'
    | '/companies/$companyId/images'
    | '/companies/$companyId/readiness'
    | '/companies/$companyId/reviews'
    | '/companies/$companyId/settings'
    | '/companies/$companyId/'
    | '/companies/$companyId/appointments/$appointmentId'
    | '/companies/$companyId/services/$serviceId'
    | '/companies/$companyId/appointments/'
    | '/companies/$companyId/employees/'
    | '/companies/$companyId/services/'
    | '/companies/$companyId/employees/$employeeId/work-hours'
    | '/companies/$companyId/services/$serviceId/assignments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/login'
    | '/activity'
    | '/appointments'
    | '/dashboard'
    | '/reports'
    | '/reviews'
    | '/sessions'
    | '/account/appearance'
    | '/account/profile'
    | '/account/sessions'
    | '/companies/pending'
    | '/users/$userId'
    | '/account'
    | '/companies'
    | '/users'
    | '/companies/$companyId/availability'
    | '/companies/$companyId/images'
    | '/companies/$companyId/readiness'
    | '/companies/$companyId/reviews'
    | '/companies/$companyId/settings'
    | '/companies/$companyId'
    | '/companies/$companyId/appointments/$appointmentId'
    | '/companies/$companyId/services/$serviceId'
    | '/companies/$companyId/appointments'
    | '/companies/$companyId/employees'
    | '/companies/$companyId/services'
    | '/companies/$companyId/employees/$employeeId/work-hours'
    | '/companies/$companyId/services/$serviceId/assignments'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forbidden'
    | '/login'
    | '/_authenticated/activity'
    | '/_authenticated/appointments'
    | '/_authenticated/dashboard'
    | '/_authenticated/reports'
    | '/_authenticated/reviews'
    | '/_authenticated/sessions'
    | '/_authenticated/account/appearance'
    | '/_authenticated/account/profile'
    | '/_authenticated/account/sessions'
    | '/_authenticated/companies/$companyId'
    | '/_authenticated/companies/pending'
    | '/_authenticated/users/$userId'
    | '/_authenticated/account/'
    | '/_authenticated/companies/'
    | '/_authenticated/users/'
    | '/_authenticated/companies/$companyId/availability'
    | '/_authenticated/companies/$companyId/images'
    | '/_authenticated/companies/$companyId/readiness'
    | '/_authenticated/companies/$companyId/reviews'
    | '/_authenticated/companies/$companyId/settings'
    | '/_authenticated/companies/$companyId/'
    | '/_authenticated/companies/$companyId/appointments/$appointmentId'
    | '/_authenticated/companies/$companyId/services/$serviceId'
    | '/_authenticated/companies/$companyId/appointments/'
    | '/_authenticated/companies/$companyId/employees/'
    | '/_authenticated/companies/$companyId/services/'
    | '/_authenticated/companies/$companyId/employees/$employeeId/work-hours'
    | '/_authenticated/companies/$companyId/services/$serviceId/assignments'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments': {
      id: '/_authenticated/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reviews': {
      id: '/_authenticated/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof AuthenticatedReviewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sessions': {
      id: '/_authenticated/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AuthenticatedSessionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/appearance': {
      id: '/_authenticated/account/appearance'
      path: '/account/appearance'
      fullPath: '/account/appearance'
      preLoaderRoute: typeof AuthenticatedAccountAppearanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/profile': {
      id: '/_authenticated/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthenticatedAccountProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/sessions': {
      id: '/_authenticated/account/sessions'
      path: '/account/sessions'
      fullPath: '/account/sessions'
      preLoaderRoute: typeof AuthenticatedAccountSessionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId': {
      id: '/_authenticated/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/pending': {
      id: '/_authenticated/companies/pending'
      path: '/companies/pending'
      fullPath: '/companies/pending'
      preLoaderRoute: typeof AuthenticatedCompaniesPendingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId/': {
      id: '/_authenticated/companies/$companyId/'
      path: '/'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/availability': {
      id: '/_authenticated/companies/$companyId/availability'
      path: '/availability'
      fullPath: '/companies/$companyId/availability'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAvailabilityRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/images': {
      id: '/_authenticated/companies/$companyId/images'
      path: '/images'
      fullPath: '/companies/$companyId/images'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdImagesRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/readiness': {
      id: '/_authenticated/companies/$companyId/readiness'
      path: '/readiness'
      fullPath: '/companies/$companyId/readiness'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdReadinessRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/reviews': {
      id: '/_authenticated/companies/$companyId/reviews'
      path: '/reviews'
      fullPath: '/companies/$companyId/reviews'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdReviewsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/settings': {
      id: '/_authenticated/companies/$companyId/settings'
      path: '/settings'
      fullPath: '/companies/$companyId/settings'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdSettingsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/appointments/': {
      id: '/_authenticated/companies/$companyId/appointments/'
      path: '/appointments'
      fullPath: '/companies/$companyId/appointments/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/appointments/$appointmentId': {
      id: '/_authenticated/companies/$companyId/appointments/$appointmentId'
      path: '/appointments/$appointmentId'
      fullPath: '/companies/$companyId/appointments/$appointmentId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/employees/': {
      id: '/_authenticated/companies/$companyId/employees/'
      path: '/employees'
      fullPath: '/companies/$companyId/employees/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/services/': {
      id: '/_authenticated/companies/$companyId/services/'
      path: '/services'
      fullPath: '/companies/$companyId/services/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdServicesIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/services/$serviceId': {
      id: '/_authenticated/companies/$companyId/services/$serviceId'
      path: '/services/$serviceId'
      fullPath: '/companies/$companyId/services/$serviceId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/employees/$employeeId/work-hours': {
      id: '/_authenticated/companies/$companyId/employees/$employeeId/work-hours'
      path: '/employees/$employeeId/work-hours'
      fullPath: '/companies/$companyId/employees/$employeeId/work-hours'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute
    }
    '/_authenticated/companies/$companyId/services/$serviceId/assignments': {
      id: '/_authenticated/companies/$companyId/services/$serviceId/assignments'
      path: '/assignments'
      fullPath: '/companies/$companyId/services/$serviceId/assignments'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRoute
    }
  }
}

interface AuthenticatedCompaniesCompanyIdServicesServiceIdRouteChildren {
  AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute: typeof AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute
}

const AuthenticatedCompaniesCompanyIdServicesServiceIdRouteChildren: AuthenticatedCompaniesCompanyIdServicesServiceIdRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute:
      AuthenticatedCompaniesCompanyIdServicesServiceIdAssignmentsRoute,
  }

const AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren =
  AuthenticatedCompaniesCompanyIdServicesServiceIdRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdServicesServiceIdRouteChildren,
  )

interface AuthenticatedCompaniesCompanyIdRouteChildren {
  AuthenticatedCompaniesCompanyIdAvailabilityRoute: typeof AuthenticatedCompaniesCompanyIdAvailabilityRoute
  AuthenticatedCompaniesCompanyIdImagesRoute: typeof AuthenticatedCompaniesCompanyIdImagesRoute
  AuthenticatedCompaniesCompanyIdReadinessRoute: typeof AuthenticatedCompaniesCompanyIdReadinessRoute
  AuthenticatedCompaniesCompanyIdReviewsRoute: typeof AuthenticatedCompaniesCompanyIdReviewsRoute
  AuthenticatedCompaniesCompanyIdSettingsRoute: typeof AuthenticatedCompaniesCompanyIdSettingsRoute
  AuthenticatedCompaniesCompanyIdIndexRoute: typeof AuthenticatedCompaniesCompanyIdIndexRoute
  AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute: typeof AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute
  AuthenticatedCompaniesCompanyIdServicesServiceIdRoute: typeof AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren
  AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute: typeof AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute
  AuthenticatedCompaniesCompanyIdEmployeesIndexRoute: typeof AuthenticatedCompaniesCompanyIdEmployeesIndexRoute
  AuthenticatedCompaniesCompanyIdServicesIndexRoute: typeof AuthenticatedCompaniesCompanyIdServicesIndexRoute
  AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute: typeof AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute
}

const AuthenticatedCompaniesCompanyIdRouteChildren: AuthenticatedCompaniesCompanyIdRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdAvailabilityRoute:
      AuthenticatedCompaniesCompanyIdAvailabilityRoute,
    AuthenticatedCompaniesCompanyIdImagesRoute:
      AuthenticatedCompaniesCompanyIdImagesRoute,
    AuthenticatedCompaniesCompanyIdReadinessRoute:
      AuthenticatedCompaniesCompanyIdReadinessRoute,
    AuthenticatedCompaniesCompanyIdReviewsRoute:
      AuthenticatedCompaniesCompanyIdReviewsRoute,
    AuthenticatedCompaniesCompanyIdSettingsRoute:
      AuthenticatedCompaniesCompanyIdSettingsRoute,
    AuthenticatedCompaniesCompanyIdIndexRoute:
      AuthenticatedCompaniesCompanyIdIndexRoute,
    AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute:
      AuthenticatedCompaniesCompanyIdAppointmentsAppointmentIdRoute,
    AuthenticatedCompaniesCompanyIdServicesServiceIdRoute:
      AuthenticatedCompaniesCompanyIdServicesServiceIdRouteWithChildren,
    AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute:
      AuthenticatedCompaniesCompanyIdAppointmentsIndexRoute,
    AuthenticatedCompaniesCompanyIdEmployeesIndexRoute:
      AuthenticatedCompaniesCompanyIdEmployeesIndexRoute,
    AuthenticatedCompaniesCompanyIdServicesIndexRoute:
      AuthenticatedCompaniesCompanyIdServicesIndexRoute,
    AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute:
      AuthenticatedCompaniesCompanyIdEmployeesEmployeeIdWorkHoursRoute,
  }

const AuthenticatedCompaniesCompanyIdRouteWithChildren =
  AuthenticatedCompaniesCompanyIdRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRoute
  AuthenticatedAppointmentsRoute: typeof AuthenticatedAppointmentsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedReviewsRoute: typeof AuthenticatedReviewsRoute
  AuthenticatedSessionsRoute: typeof AuthenticatedSessionsRoute
  AuthenticatedAccountAppearanceRoute: typeof AuthenticatedAccountAppearanceRoute
  AuthenticatedAccountProfileRoute: typeof AuthenticatedAccountProfileRoute
  AuthenticatedAccountSessionsRoute: typeof AuthenticatedAccountSessionsRoute
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRouteWithChildren
  AuthenticatedCompaniesPendingRoute: typeof AuthenticatedCompaniesPendingRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,
  AuthenticatedAppointmentsRoute: AuthenticatedAppointmentsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedReviewsRoute: AuthenticatedReviewsRoute,
  AuthenticatedSessionsRoute: AuthenticatedSessionsRoute,
  AuthenticatedAccountAppearanceRoute: AuthenticatedAccountAppearanceRoute,
  AuthenticatedAccountProfileRoute: AuthenticatedAccountProfileRoute,
  AuthenticatedAccountSessionsRoute: AuthenticatedAccountSessionsRoute,
  AuthenticatedCompaniesCompanyIdRoute:
    AuthenticatedCompaniesCompanyIdRouteWithChildren,
  AuthenticatedCompaniesPendingRoute: AuthenticatedCompaniesPendingRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
